import * as React from "react";

const STORAGE_KEY = "backland_offers_exit_seen";
const ONE_DAY_MS = 24 * 60 * 60 * 1000;
const MIN_DWELL_MS = 20_000;

function shouldFire(): boolean {
  if (typeof window === "undefined") return false;
  // Skip touch devices
  if (window.matchMedia?.("(pointer: coarse)").matches) return false;
  // Skip on offers/book routes
  const path = window.location.pathname;
  if (path.startsWith("/offers") || path.startsWith("/book")) return false;
  // Skip if booking widget is opening
  if (document.body.classList.contains("booking-widget-opening")) return false;
  // Skip if another dialog is already open
  const openDialog = document.querySelector(
    '[role="dialog"][data-state="open"]',
  );
  if (openDialog) return false;
  // Once per day
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const ts = parseInt(raw, 10);
      if (!Number.isNaN(ts) && Date.now() - ts < ONE_DAY_MS) return false;
    }
  } catch {
    // ignore
  }
  return true;
}

export function useExitIntentOffers(
  isOpen: boolean,
  onTrigger: () => void,
): void {
  const firedRef = React.useRef(false);
  const mountedAtRef = React.useRef(Date.now());

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia?.("(pointer: coarse)").matches) return;

    const handler = (e: MouseEvent) => {
      if (firedRef.current) return;
      if (isOpen) return;
      if (e.clientY > 0) return;
      if (Date.now() - mountedAtRef.current < MIN_DWELL_MS) return;
      if (!shouldFire()) return;
      firedRef.current = true;
      try {
        window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch {
        // ignore
      }
      onTrigger();
    };

    document.addEventListener("mouseleave", handler);
    return () => document.removeEventListener("mouseleave", handler);
  }, [isOpen, onTrigger]);
}
